module.exports = "/_next/static/images/easy_implementation-dab80bae2f23fd2605fd4fdd835f12c3.svg";